<div class="block form-admin">
	<header class="header-admin">
		<h1 class="admin">Etats des commandes</h1>
		<div>
			<a href="" [routerLink]="route.get('order-state-form')"><i class="fa-solid fa-layer-plus"></i></a>
		</div>
	</header>
	<router-outlet></router-outlet>
</div>